import callIdApi from "../../util/idApiCaller";

export const SET_AGENT = 'SET_AGENT';
export const SET_AGENT_LIST = 'SET_AGENT_LIST';
export const TOGGLE_ALL_SEARCHLINK_FILTERS = 'TOGGLE_ALL_SEARCHLINK_FILTERS';

export function setAgent(agent) {
    return (dispatch) => {
        dispatch({
            type: SET_AGENT,
            agent: agent
        });
    };
}


export function setAgentList(agentList) {
    return (dispatch) => {
        dispatch({
            type: SET_AGENT_LIST,
            agentList: agentList
        });
    };
}

export function toggleAllSearchlinkFilters (val) {
    debugger
    return (dispatch) => {
        dispatch({
            type: TOGGLE_ALL_SEARCHLINK_FILTERS,
            isFiltersVisible: val
        })
    }
}

export function fetchAgentList () {
    return (dispatch) => {
       return  callIdApi(`api/v3/agents/agent-list`, 'POST', {}).then(res => {
            if (res.status === "Success") {
                dispatch(setAgentList(res?.data?.agents))
            }
        });
    }
}
